
$(document).ready(function(){

    $(".content-slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      speed: 1000,
      centerMode: true,
      dots: true,
    });
  
  setTimeout(() => {
        $(".product-slider").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
    });
   
}, 2000);

      
});